export default {
  API_KEY: 'FORM/API_KEY',
  CHANGE_EMAIL: 'FORM/CHANGE_EMAIL',
  CHANGE_PASSWORD: 'FORM/CHANGE_PASSWORD',
  FORGOT_PASSWORD: 'FORM/FORGOT_PASSWORD',
  PREFERENCES: 'FORM/PREFERENCES',
  PROFILE: 'FORM/PROFILE',
  REQUEST_HISTORY: 'FORM/REQUEST_HISTORY',
  SIMPLE_TRADE: 'FORM/SIMPLE_TRADE',
  TICKET: 'FORM/TICKET',
  TIER_TWO: 'FORM/TIER_TWO',
  TWO_FACTOR: 'FORM/TWO_FACTOR',
  WHITELIST_ADDRESS: 'FORM/WHITELIST_ADDRESS'
}
